<template>
  <path
    d="M3 21.0002H20C20.55 21.0002 21 20.5502 21 20.0002V19.0002C21 18.4502 20.55 18.0002 20 18.0002H3C2.45 18.0002 2 18.4502 2 19.0002V20.0002C2 20.5502 2.45 21.0002 3 21.0002ZM20 8.00024H3C2.45 8.00024 2 8.45024 2 9.00024V15.0002C2 15.5502 2.45 16.0002 3 16.0002H20C20.55 16.0002 21 15.5502 21 15.0002V9.00024C21 8.45024 20.55 8.00024 20 8.00024ZM2 4.00024V5.00024C2 5.55024 2.45 6.00024 3 6.00024H20C20.55 6.00024 21 5.55024 21 5.00024V4.00024C21 3.45024 20.55 3.00024 20 3.00024H3C2.45 3.00024 2 3.45024 2 4.00024Z"
  />
</template>
